import { useDataFormatter } from "@/composable/data-formatter";
import { DataDefinition } from "@soft-db/data-formatter";
import { Base64Query } from "@soft-db/monitoring-api-client";
import { fromBase64 } from "@soft-db/soft-utils";
import { PropType } from "vue";

export default defineComponent({
	name: "AlertConditionData",
	props: {
		query: {
			type: Object as PropType<Base64Query>,
			required: true,
		},
	},
	setup(props) {
		const { generateDataLabel } = useDataFormatter();

		const data = computed(() => {
			const { query } = props.query;
			const definition: DataDefinition = JSON.parse(fromBase64(query));

			return generateDataLabel(definition);
		});
		return () => <div>{data.value}</div>;
	},
});
